// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../../../../../.nvm/versions/node/v10.0.0/lib/node_modules/@core/macys-cli/node_modules/css-loader/index.js??ref--1-1!../../../../../../../../../../../.nvm/versions/node/v10.0.0/lib/node_modules/@core/macys-cli/node_modules/sass-loader/lib/loader.js??ref--1-2!./modal-overlay.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../../../../../../../../../../.nvm/versions/node/v10.0.0/lib/node_modules/@core/macys-cli/node_modules/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../../../../.nvm/versions/node/v10.0.0/lib/node_modules/@core/macys-cli/node_modules/css-loader/index.js??ref--1-1!../../../../../../../../../../../.nvm/versions/node/v10.0.0/lib/node_modules/@core/macys-cli/node_modules/sass-loader/lib/loader.js??ref--1-2!./modal-overlay.scss", function() {
			var newContent = require("!!../../../../../../../../../../../.nvm/versions/node/v10.0.0/lib/node_modules/@core/macys-cli/node_modules/css-loader/index.js??ref--1-1!../../../../../../../../../../../.nvm/versions/node/v10.0.0/lib/node_modules/@core/macys-cli/node_modules/sass-loader/lib/loader.js??ref--1-2!./modal-overlay.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@component/modal-overlay/src/scss/_dontExtract_/mcom/modal-overlay.scss
// module id = 408
// module chunks = 9